module.exports = __webpack_public_path__ + "img/Littledart-Fulfilment-Logo-High-Resolution-Transparent-Colour-1024x205.ad4d7d37.png";